import React from 'react';
import { Grid } from '@mui/material';

const AttrGrid = ({ children, alignItems = 'center' }) => (
  <Grid container direction="row" spacing={2} alignItems={alignItems} className="attr-grid">
    {children}
  </Grid>
);

export default AttrGrid;
